<template>
<div class="card" style="height: 330px;">
    <div class="card-header">
        <p class="card-header-title">Add Notification</p>
    </div>
    <div class="card-content">
        <div class="content">            
            <div class="field">
                <div class="control">
                    <input class="input is-success" type="text" placeholder="Title" v-model="input.title">
                </div>
            </div>
            <div class="field">
                <div class="control">
                    <input class="input" type="text" placeholder="Message" v-model="input.message">
                </div>
            </div>
            <div class="field">
                <div class="control">
                    <div class="myLabel">Repeat on: </div>
                    <div class="myInput">
                        <input type="checkbox" id="1" value="1" v-model="input.repeatOn"><label for="1">Monday</label>&nbsp;&nbsp;
                        <input type="checkbox" id="2" value="2" v-model="input.repeatOn"><label for="2">Tuesday</label>&nbsp;&nbsp;
                        <input type="checkbox" id="3" value="3" v-model="input.repeatOn"><label for="3">Wednesday</label>&nbsp;&nbsp;
                        <input type="checkbox" id="4" value="4" v-model="input.repeatOn"><label for="4">Thursday</label>&nbsp;&nbsp;
                        <input type="checkbox" id="5" value="5" v-model="input.repeatOn"><label for="5">Friday</label>&nbsp;&nbsp;
                        <input type="checkbox" id="6" value="6" v-model="input.repeatOn"><label for="6">Saturday</label>&nbsp;&nbsp;
                        <input type="checkbox" id="0" value="0" v-model="input.repeatOn"><label for="0">Sunday</label>&nbsp;&nbsp;
                    </div>
                </div>
            </div>
            <div class="field">
                <div class="control">
                    <div class="myLabel">Time:</div> <div class="myInput">
                        <b-select id="dataType" name="dataType" v-model="input.repeatTime">
                            <option selected value="7">7 a.m.</option>
                            <option value="8">8 a.m.</option>
                            <option value="9">9 a.m.</option>
                            <option value="10">10 a.m.</option>
                            <option value="11">11 a.m.</option>
                            <option value="12">12 p.m.</option>
                            <option value="13">1 p.m.</option>
                            <option value="14">2 p.m.</option>
                            <option value="15">3 p.m.</option>
                            <option value="16">4 p.m.</option>
                            <option value="17">5 p.m.</option>
                            <option value="18">6 p.m.</option>
                            <option value="19">7 p.m.</option>
                            <option value="20">8 p.m.</option>
                            <option value="21">9 p.m.</option>
                            <option value="22">10 p.m.</option>
                            <option value="23">11 p.m.</option>
                            <option value="0">12 a.m.</option>
                            <option value="1">1 a.m.</option>
                            <option value="2">2 a.m.</option>
                            <option value="3">3 a.m.</option>
                            <option value="4">4 a.m.</option>
                            <option value="5">5 a.m.</option>
                            <option value="6">6 a.m.</option>
                        </b-select>
                        <!-- <vue-timepicker v-model="input.repeatTime"></vue-timepicker> -->
                    </div>
                </div>
            </div>
            <div class="field">
                <div class="control">
                    <div class="myLabel">Status:</div> 
                    <div class="myInput">
                        <b-radio v-model="input.status" native-value="1">
                            Active
                        </b-radio>
                        <b-radio v-model="input.status" native-value="0">
                            Inactive
                        </b-radio>
                    </div>
                </div>
            </div>
            <div class="field">
                <button class='button is-primary  is-fullwidth' v-on:click="sendForm()">Create</button>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import axios from 'axios'
import { ToastProgrammatic as Toast } from 'buefy'

export default {
    data() {
        return {    
            input: {
                title: '',
                message: '',
                repeatOn: [],
                repeatTime: 7,
                target: 1,   //for teacher app
                status: 1
            },
            schoolPlan: 1
        };
    },
    created() {
        var getSchoolPlan = localStorage.getItem('plan')
        if (getSchoolPlan){
            this.schoolPlan = getSchoolPlan
        }
    },
    methods: {
        sendForm() {
            if (this.schoolPlan == 3){
                Toast.open({
                    message: "Sorry, your account plan doesn't allow you to create any notifications. Please upgrade your account to start creating badges.",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }
            if (this.input.title.length > 0 && this.input.message.length > 0 && this.input.repeatOn.length > 0) {
                const title = this.input.title;
                const message = this.input.message;
                this.$emit('add-notification', {
                    title,
                    message,
                    done: false,
                });

                this.input.email = localStorage.getItem('email')
                this.input.sessionID = localStorage.getItem('sessionID')

                axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
                axios.defaults.responseType = 'json'
                axios.post(process.env.MY_URL + '/api/notifications/add', this.input)

                    .then(response => {
                        console.log("90 response: ")
                        console.log(response)
                        if (response.data.success == false) {
                            Toast.open({
                                message: response.data.msg,
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 5000
                            })
                        } else {
                            Toast.open({
                                color: 'is-dark', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                message: "Notification added successfully",
                                type: 'is-success',
                                duration: 3000
                            })
                            console.log("OK 157")
                            this.$parent.getNotifications()
                        }

                        this.input.title = '';
                        this.input.message = '';
                        this.input.repeatOn = [];
                    })
                    .catch(e => {
                        console.log("172?")
                        console.log(e)
                        if (e.response.status === 401) {
                            console.log("salah login")
                            this.errors.push("Invalid login")                            
                            alert("Unauthorized access. Please re-login.")
                        } else {
                            
                            Toast.open({
                                message: "Sorry, an error has occurred. Please try again later.",
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 3000
                            })
                        }
                    })
            } else {
                Toast.open({
                    message: "Please enter the values for all the fields.",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }
        },
    },
};
</script>
<style scoped>
.myLabel{
    float: left;
    width: 15%;
    padding: 5px;
}
.myInput{
    float: left;
    width: 80%;
    padding: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/Notifications/AddNotificationTeacher.vue